import { Channel } from "@swivl-mono/types";
import React, { Component } from "react";

import { SwivlChat } from "../SwivlChat";
import { LanguageContext, t } from "../i18n/strings";
import SwivlChatInterface from "../interface/SwivlChatInterface";
import "./Form.scss";

export interface FormProps {
  delegate: SwivlChat;
  isConversationTakenOver: boolean;
  canTakeoverViaSMS: boolean;
}
export interface FormState {
  text: string;
  justTookover: boolean;
}
export interface FormInterface {
  sendText(text: string): void;
}

export class Form extends React.Component<FormProps, FormState> implements FormInterface {
  static contextType = LanguageContext;
  declare context: React.ContextType<typeof LanguageContext>;
  hasSentTyping: boolean = false;
  textAreaRef: React.RefObject<HTMLTextAreaElement> = React.createRef();
  inputFocus;
  constructor(props: FormProps) {
    super(props);
    this.state = { text: "", justTookover: false };
    this.onKeyDown = this.onKeyDown.bind(this);
    this.onChange = this.onChange.bind(this);
    this.sendText = this.sendText.bind(this);

    this.onFocus = this.onFocus.bind(this);
    this.onBlur = this.onBlur.bind(this);
    this.sendText = this.sendText.bind(this);
    this.startConversationClicked = this.startConversationClicked.bind(this);
    this.startConversationViaWebClicked = this.startConversationViaWebClicked.bind(this);
    this.startConversationViaSMSClicked = this.startConversationViaSMSClicked.bind(this);
    this.startConversationViaWhatsAppClicked = this.startConversationViaWhatsAppClicked.bind(this);
  }

  onKeyDown(event: React.KeyboardEvent<HTMLInputElement | HTMLTextAreaElement>): void {
    if (event.key === "Enter") {
      this.sendText();
    }
  }
  onFocus(): void {
    if (this.props.delegate.props.onFormFocus) {
      this.props.delegate.props.onFormFocus();
    }
  }
  onBlur(): void {
    if (this.props.delegate.props.onFormBlur) {
      this.props.delegate.props.onFormBlur();
    }
  }

  onChange(event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) {
    this.setState({ text: event.target.value });

    if (event.target.value && event.target.value.length && !this.hasSentTyping) {
      this.hasSentTyping = true;
      this.props.delegate.messageHandler.sendTypingFrame(true);
    } else if (event.target.value.length == 0) {
      this.hasSentTyping = false;
      this.props.delegate.messageHandler.sendTypingFrame(false);
    }
  }
  sendText() {
    if (this.state.text.length > 0) {
      if (this.state.text == "/reset") {
        this.props.delegate.resetConversation();
        this.setState({ text: "" });

        return;
      }
      this.hasSentTyping = false;

      if (/\S/.test(this.state.text)) {
        this.props.delegate.messageHandler.sendTextMessage(this.state.text.trim());
      }
      setTimeout(() => {
        this.setState({ text: "" });
        this.hasSentTyping = false;
        this.props.delegate.messageHandler.sendTypingFrame(false);
      }, 10);
      // this.setState({text:""});
    }
  }
  startConversationClicked() {
    this.triggerTakeover();
  }
  startConversationViaWebClicked() {
    this.triggerTakeover(Channel.WEB);
  }
  startConversationViaSMSClicked() {
    this.triggerTakeover(Channel.SMS);
  }
  startConversationViaWhatsAppClicked() {
    this.triggerTakeover(Channel.WHATSAPP);
  }
  triggerTakeover(takeoverChannel?: Channel) {
    this.setState({ justTookover: true });
    if (this.props.delegate.props.takeoverConversation) {
      this.props.delegate.props.takeoverConversation(takeoverChannel);
    }
    setTimeout(() => {
      this.setState({ justTookover: false });
    }, 6000);
  }

  render() {
    const className = "scc-form swivl-form scc-normalInput";

    if (this.props.delegate.props.canTakeOver && !this.state.justTookover && !this.props.isConversationTakenOver) {
      if (this.props.canTakeoverViaSMS) {
        return (
          <div className={className + " scc-takeoverForm"}>
            <button className="scc-takeoverConversationViaWebButton swivl-primaryButton" onClick={this.startConversationViaWebClicked}>
              Takeover via Web
            </button>
            <button className="scc-takeoverConversationViaSMSButton swivl-primaryButton" onClick={this.startConversationViaSMSClicked}>
              Takeover via SMS
            </button>
            <button className="scc-takeoverConversationViaWhatsAppButton swivl-primaryButton" onClick={this.startConversationViaWhatsAppClicked}>
              Takeover via WhatsApp
            </button>
          </div>
        );
      }

      return (
        <div className={className + " scc-takeoverForm"}>
          <button className="scc-takeoverConversationButton swivl-primaryButton" onClick={this.startConversationClicked}>
            Takeover Conversation
          </button>
        </div>
      );
    }

    const input = (
      <input
        className="scc-formInput swivl-form"
        onFocus={this.onFocus}
        onBlur={this.onBlur}
        onChange={this.onChange}
        value={this.state.text}
        onKeyDown={this.onKeyDown}
        placeholder={t("formInputPlaceholder", this.context)}
        autoComplete={"off"}
        id="scc-form-input"
      />
    );

    return (
      <div className={className}>
        {input}
        <button className="scc-formButton swivl-primaryButton" onClick={this.sendText}>
          {t("formSendButton", this.context)}
        </button>
      </div>
    );
  }
}
